'use client';

import * as Dialog from '@radix-ui/react-dialog';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import styles from './AlertModal.module.scss';
interface AlertModalProps {
  message: string;
  isOpen: boolean;
  onClose: () => void;
}
export default function AlertModal({
  message,
  isOpen,
  onClose
}: Readonly<AlertModalProps>) {
  const pathname = usePathname();
  const mountedPathnameRef = useRef<string | null>(null);
  useEffect(() => {
    if (mountedPathnameRef.current === null) {
      mountedPathnameRef.current = pathname;
      return;
    }
    if (isOpen && pathname !== mountedPathnameRef.current) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return <Dialog.Root open={isOpen} onOpenChange={open => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.alertOverlay} />
        <Dialog.Content className={styles.alertContainer}>
          <Dialog.Title asChild>
            <div className={styles.alertContent}>
              <p className={styles.alertMessage}>{message}</p>
            </div>
          </Dialog.Title>
          <Dialog.Description asChild>
            <div className="sr-only">알림 모달</div>
          </Dialog.Description>
          <Dialog.Close asChild>
            <button type="button" className={styles.alertConfirmButton} onClick={onClose}>
              확인
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>;
}